/**
 * Pure helper functions for Google Keep style reminder popover presets and formatting.
 */

export function toDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getTomorrowReminder(referenceDate: Date = new Date()): {
  due: string;
  time: string;
  label: string;
  timeLabel: string;
} {
  const tomorrow = new Date(referenceDate);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return {
    due: toDateString(tomorrow),
    time: '08:00',
    label: 'Mañana',
    timeLabel: '8:00 a.m.',
  };
}

export function getNextWeekReminder(referenceDate: Date = new Date()): {
  due: string;
  time: string;
  label: string;
  timeLabel: string;
} {
  const target = new Date(referenceDate);
  const currentDay = target.getDay(); // 0 = Sun, 1 = Mon, ..., 6 = Sat
  // Days until next Monday
  const daysUntilNextMonday = currentDay === 0 ? 1 : (8 - currentDay);
  target.setDate(target.getDate() + daysUntilNextMonday);

  return {
    due: toDateString(target),
    time: '08:00',
    label: 'Semana siguiente',
    timeLabel: 'lun, 8:00 a.m.',
  };
}

export function formatDisplayReminder(due: string, time?: string): string {
  if (!due) return '';
  const [year, month, day] = due.split('-').map(Number);
  if (!year || !month || !day) return due;

  const today = new Date();
  const todayStr = toDateString(today);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowStr = toDateString(tomorrow);

  let datePrefix = '';
  if (due === todayStr) {
    datePrefix = 'Hoy';
  } else if (due === tomorrowStr) {
    datePrefix = 'Mañana';
  } else {
    // Format e.g. "15 abr"
    const monthNames = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    datePrefix = `${day} ${monthNames[month - 1] || ''}`;
  }

  if (time) {
    const [hStr, mStr] = time.split(':');
    const h = Number(hStr);
    const m = mStr || '00';
    if (!Number.isNaN(h)) {
      const isPm = h >= 12;
      const displayHour = h % 12 === 0 ? 12 : h % 12;
      const ampm = isPm ? 'p.m.' : 'a.m.';
      const timeFormatted = m === '00' ? `${displayHour}:00 ${ampm}` : `${displayHour}:${m} ${ampm}`;
      return `${datePrefix}, ${timeFormatted}`;
    }
    return `${datePrefix}, ${time}`;
  }

  return datePrefix;
}
